export default {"src":"/_next/static/media/training.3f5912f7.svg","height":2500,"width":2500,"blurWidth":0,"blurHeight":0};